import Container from "@material-ui/core/Container";
import * as React from "react";
import { makeStyles } from "@material-ui/styles";
const useStyles = makeStyles(({
  breakpoints,
  typography
}) => ({
  container: {
    [breakpoints.down("xs")]: {
      paddingLeft: typography.pxToRem(10),
      paddingRight: typography.pxToRem(10)
    },
    [breakpoints.up("sm")]: {
      paddingBottom: typography.pxToRem(40)
    }
  },
  maxWidth: {
    [breakpoints.up("sm")]: {
      maxWidth: typography.pxToRem(980)
    }
  }
}));

const FluidContainer = ({
  children
}) => {
  const styles = useStyles();
  return /*#__PURE__*/React.createElement(Container, {
    maxWidth: "md",
    classes: {
      root: styles.container,
      maxWidthMd: styles.maxWidth
    }
  }, children);
};

export default FluidContainer;